import { forwardRef, type ButtonHTMLAttributes, type HTMLAttributes, type ReactNode } from 'react'
import { cx } from './cx'

type Tone = { gold?: boolean; locked?: boolean }

type PlankButtonProps = Tone & ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode; innerClassName?: string }

/** Bevelled bronze plank used as a text button. Locked planks are disabled. */
export const PlankButton = forwardRef<HTMLButtonElement, PlankButtonProps>(function PlankButton(
  { gold, locked, className, innerClassName, children, disabled, type = 'button', ...rest }, ref) {
  return (
    <button ref={ref} type={type} className={cx('plank', gold && 'plank--gold', locked && 'plank--locked', className)} disabled={disabled || locked} {...rest}>
      <span className={cx('plank__in', innerClassName)}>{children}</span>
    </button>
  )
})

type PlankLabelProps = Tone & HTMLAttributes<HTMLDivElement> & { children: ReactNode; innerClassName?: string }

/** Plank as a label or heading (not interactive). */
export function Plank({ gold, locked, className, innerClassName, children, ...rest }: PlankLabelProps) {
  return (
    <div className={cx('plank', gold && 'plank--gold', locked && 'plank--locked', className)} {...rest}>
      <div className={cx('plank__in', innerClassName)}>{children}</div>
    </div>
  )
}
